export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9529.d415555b.jpg";